// It equals to EntityType on be side
export var EStructureItem;
(function (EStructureItem) {
    EStructureItem["Settings"] = "Settings";
    EStructureItem["Element"] = "Element";
    EStructureItem["Model"] = "Model";
    EStructureItem["Task"] = "Task";
    EStructureItem["LogicalElement"] = "LogicalElement";
    EStructureItem["Dataset"] = "Dataset";
    EStructureItem["Sample"] = "Sample";
    EStructureItem["Blend"] = "Blend";
    EStructureItem["Reaction"] = "Reaction";
    EStructureItem["ElementResult"] = "ElementResult";
    EStructureItem["SampleResult"] = "SampleResult";
    EStructureItem["BlendResult"] = "BlendResult";
})(EStructureItem || (EStructureItem = {}));
//# sourceMappingURL=structure.enum.js.map